import { type InitFlowComponent } from '@capsicum/common';
import { isRegisteredSuccessAtom } from '@capsicum/socios-core';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

export const IsOnboardingCompleted: InitFlowComponent = ({ fallback, isReactive, next }) => {
	const setIsRegisteredSuccessAtom = useSetAtom(isRegisteredSuccessAtom);

	useEffect(() => {
		if (!isReactive) {
			next();

			return;
		}
		setIsRegisteredSuccessAtom(false);
	}, [isReactive, next, setIsRegisteredSuccessAtom]);

	return fallback;
};

IsOnboardingCompleted.keepAlive = true;
